






















import { Component, Prop, Emit, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';
import { RouteName } from '../../routes/routes.constants';

@Component
export default class MainNavigationItem extends Mixins(MagicConfigMixin) {
    @Prop(String) link!: string;
    @Prop(String) target!: string;
    @Prop(String) topNavVariant!: boolean;

    get isExternalLink(): boolean {
        return (
            this.link.startsWith('https://') ||
            this.link.startsWith('http://')
        )
    }
    get targetValue(): string | undefined {
        return this.target || undefined
    }

    get isSportsRoute() {
        const sportsbookRoute = this.$route.name;
        if (sportsbookRoute === RouteName.SPORTSBOOK && this.link.includes('/sports')) {
            return true;
        } 

        return false;
    }

    @Emit('click')
    emitClick() {
        return
    }
}
